export const DEFAULT_LOADING_CLIP_DETAIL_TRANSCRIPT_MESSAGE =
  'Loading transcript...';
